































































import type { PageDataPropUnion } from "@constructor/shared-entity/type";
import { defineComponent, type PropType } from "vue-demi";
import getValueForProp from "../../../helper/getValueForProp";
import GGTimerBlock from "../../grid-generation/GGTimerBlock.vue";
import GGPromoButton from "../../grid-generation/GGPromoButton/GGPromoButton.vue";

export default defineComponent({
  name: "FCPromo",
  components: {
    GGTimerBlock,
    GGPromoButton,
  },
  props: {
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
  },
  computed: {
    backgroundDesktop() {
      return getValueForProp("bannerImageDesktop", this.prop);
    },
    backgroundMobile() {
      return getValueForProp("bannerImageMobile", this.prop);
    },
    backgroundColor() {
      return getValueForProp("bannerBackgroundColor", this.prop) || undefined;
    },
    buttonType() {
      return getValueForProp("promocodeButtonType", this.prop);
    },

    promoButtonColor() {
      return getValueForProp("promocodeButtonColor", this.prop) || undefined;
    },
    promocode() {
      return getValueForProp("promocode", this.prop) || undefined;
    },

    link() {
      return getValueForProp("buttonLink", this.prop) || undefined;
    },
    linkText() {
      return getValueForProp("buttonLinkText", this.prop) || undefined;
    },

    timerSize() {
      return getValueForProp("timerSize", this.prop) || undefined;
    },
    timerColor() {
      return getValueForProp("timerColor", this.prop) || undefined;
    },
    timerDate() {
      return getValueForProp("timerDate", this.prop) || undefined;
    },
  },
});
